import script from "./FormulasBurn.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasBurn.vue?vue&type=script&setup=true&lang=js"

import "./FormulasBurn.vue?vue&type=style&index=0&id=7c6120f6&lang=scss"

const __exports__ = script;

export default __exports__